{
  "name": "viscount-crate-tracking-frontend",
  "title": "Viscount - Crate Tracking",
  "version": "1.9.1",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "start:uat": "ng serve --configuration uat",
    "start:prod": "ng serve --configuration production",
    "build": "ng build --configuration development",
    "build:dev": "ng build --configuration development",
    "build:uat": "ng build --configuration uat",
    "build:prod": "ng build --configuration production",
    "postbuild:prod": "gzipper compress --include js,html,scss,css,svg,json ./dist/browser",
    "watch": "ng build --watch --configuration=dev",
    "deploy:uat": "sh ./deploy/deploy-from-local.dev.sh",
    "deploy:prod": "sh ./deploy/deploy-from-local.prod.sh",
    "test": "ng test",
    "test:ci": "ng test",
    "test-e2e": "npx playwright test --ui",
    "test-pw": "npx playwright test",
    "lint": "eslint \"{src,apps,libs,test}/**/*.ts\" --fix",
    "format": "prettier --write \"src/**/*.ts\" \"test/**/*.ts\"",
    "compodoc": "npx compodoc -p tsconfig.doc.json",
    "compodoc:build": "compodoc -p tsconfig.doc.json",
    "compodoc:build-and-serve": "compodoc -p tsconfig.doc.json -s",
    "compodoc:serve": "compodoc -s",
    "schema:build": "cd ../.schematics/frontend && npm i && npm run build && npm link && cd ../../frontend",
    "schema:generate": "schematics @sick-eh/schematics-fe:component"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.2.17",
    "@angular/common": "^21.2.17",
    "@angular/compiler": "^21.2.17",
    "@angular/core": "^21.2.17",
    "@angular/forms": "^21.2.17",
    "@angular/platform-browser": "^21.2.17",
    "@angular/platform-browser-dynamic": "^21.2.17",
    "@angular/router": "^21.2.17",
    "@ngneat/until-destroy": "^10.0.0",
    "@ngx-translate/core": "^14.0.0",
    "@ngx-translate/http-loader": "^7.0.0",
    "@synergy-design-system/angular": "^3.21.0",
    "@synergy-design-system/assets": "^2.3.0",
    "@synergy-design-system/components": "^3.21.0",
    "@synergy-design-system/fonts": "^1.1.0",
    "@synergy-design-system/styles": "^2.2.0",
    "@synergy-design-system/tokens": "^3.21.0",
    "dayjs": "^1.11.10",
    "echarts": "^6.1.0",
    "jsbarcode": "^3.12.3",
    "lodash-es": "^4.17.21",
    "ngx-clipboard": "^16.0.0",
    "ngx-echarts": "^21.0.0",
    "ngx-mask": "^16.3.9",
    "ngx-validators": "^6.0.1",
    "qs": "^6.11.2",
    "rxjs": "~7.5.0",
    "socket.io-client": "^4.8.3",
    "tslib": "^2.6.2"
  },
  "devDependencies": {
    "@angular/build": "^21.2.16",
    "@angular/cli": "~21.2.16",
    "@angular/compiler-cli": "^21.2.6",
    "@angular/service-worker": "^21.2.17",
    "@commitlint/cli": "^19.3.0",
    "@commitlint/config-conventional": "^19.2.2",
    "@compodoc/compodoc": "^1.1.24",
    "@faker-js/faker": "^8.4.1",
    "@hirez_io/observer-spy": "^2.2.0",
    "@playwright/test": "^1.38.1",
    "@types/jsbarcode": "^3.11.4",
    "@types/lodash-es": "^4.17.7",
    "@types/node": "^20.6.5",
    "@types/qs": "^6.9.15",
    "@typescript-eslint/eslint-plugin": "^6.0.0",
    "@typescript-eslint/parser": "^6.0.0",
    "autoprefixer": "^10.4.15",
    "eslint": "^8.42.0",
    "eslint-config-prettier": "^9.0.0",
    "eslint-plugin-prettier": "^5.0.0",
    "gzipper": "^8.2.1",
    "husky": "^9.0.11",
    "jsdom": "^28.1.0",
    "lint-staged": "^15.2.7",
    "ng-mocks": "^14.15.3",
    "postcss": "^8.4.28",
    "prettier": "^3.0.0",
    "pretty-quick": "^3.1.3",
    "sass": "^1.62.1",
    "tailwindcss": "^3.3.3",
    "typescript": "~5.9.3",
    "vitest": "^4.1.9",
    "vitest-mock-extended": "^4.0.0",
    "zone.js": "^0.16.2"
  },
  "lint-staged": {
    "{src,apps,libs,test}/**/*.{js,jsx,ts,tsx}": [
      "eslint --max-warnings=0 --fix"
    ],
    "{src,apps,libs,test}/**/*.{html,json,css,scss,md,mdx}": [
      "prettier -w"
    ]
  },
  "overrides": {
    "@babel/core": "^7.29.7",
    "ajv": "^8.20.0",
    "minimatch": "^9.0.8",
    "picomatch": "^4.0.4",
    "uuid": "^14.0.1"
  }
}
